import request from "@/utils/request";

// 列表(主数据列表)
export function loadMaterialsUnitConversionListDataApi(data) {
  return request({
    url: "web/materialsUnitConversion/listData",
    method: "post",
    data
  });
}

// 导出(主数据列表)
export function loadMaterialsUnitConversionExportDataApi(data) {
  return request({
    url: "web/materialsUnitConversion/exportData",
    method: "post",
    data
  });
}

// 下拉
export function materialsUnitConversionListSelectDataApi(data) {
  return request({
    url: "web/materialsUnitConversion/listSelectData",
    method: "post",
    data
  });
}

// 初始化
export function initMaterialsUnitConversionApi(data) {
  return request({
    url: "web/materialsUnitConversion/initMaterialsUnitConversion",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateMaterialsUnitConversionApi(data) {
  return request({
    url: "web/materialsUnitConversion/saveOrUpdate",
    method: "post",
    data
  });
}
